// src/locales/ta/messageCenterShiftLeaderCommission.js
export const messageCenterShiftLeaderCommission = {
  configureButton: 'தலைவர் கமிஷன்',
  modalTitle: 'ஷிப்ட் தலைவர் கமிஷன் அமைப்புகள்',
  enabled: 'ஷிப்ட் தலைவர் கமிஷனை இயக்கு',
  calculationMethod: 'கணக்கீட்டு முறை',
  perSalesValue: 'விற்பனை மதிப்பு அடிப்படையில்',
  otherMethodsComingSoon: 'ஆர்டர் அடிப்படையிலான மற்றும் பொருள் அடிப்படையிலான கணக்கீட்டு முறைகள் விரைவில்.',
  calculationBase: 'கணக்கீட்டு அடிப்படை',
  phaseCount: 'கட்டங்களின் எண்ணிக்கை',
  phase: 'கட்டம்',
  addTier: 'அடுக்கு சேர்',
  fixedAmount: 'நிலையான தொகை',
  targetValue: 'இலக்கு மதிப்பு',
  shifts: 'ஷிப்ட்கள்',
  orders: 'ஆர்டர்கள்',
  products: 'பொருட்கள்',
  progress: 'முன்னேற்றம்',
  saveSuccess: 'ஷிப்ட் தலைவர் கமிஷன் அமைப்புகள் வெற்றிகரமாக சேமிக்கப்பட்டன',
  saveFailed: 'ஷிப்ட் தலைவர் கமிஷன் அமைப்புகளை சேமிக்க முடியவில்லை',
  viewPageTitle: 'ஷிப்ட் தலைவர் கமிஷன்',
  viewPageDescription: 'தீர்வு மாதம் அடிப்படையில் ஷிப்ட் தலைவர்களுக்கான கட்டம் வாரியான கமிஷன் விவரம்',
  monthTotal: 'மாத மொத்தம்',
  grandTotal: 'மொத்தத் தொகை',
  featureDisabled: 'இந்த வணிகத்திற்கு ஷிப்ட் தலைவர் கமிஷன் இயக்கப்படவில்லை',
  noLeadersForMonth: 'இந்த மாதத்தில் எந்த ஷிப்ட் தலைவரும் ஷிப்டை வழிநடத்தவில்லை',
  failedToLoadReport: 'ஷிப்ட் தலைவர் கமிஷன் அறிக்கையை ஏற்ற முடியவில்லை',
  enabledHelp: 'When off, leaders earn no phase commission. Any tiers entered are still validated.',
  phaseCountPlaceholder: 'e.g. 3',
  targetValuePlaceholder: 'e.g. 5500000',
  validation: {
    targetNegative: 'Target value cannot be negative',
    minValueInvalid: 'ஒவ்வொரு அடுக்கிற்கும் சரியான, எதிர்மறையற்ற குறைந்தபட்ச மதிப்பு தேவை',
    maxValueRequired: 'கடைசி அடுக்கு தவிர மற்ற அனைத்து அடுக்குகளுக்கும் அதிகபட்ச மதிப்பு தேவை',
    rateInvalid: 'ஒவ்வொரு அடுக்கிற்கும் சரியான, எதிர்மறையற்ற விகிதம் தேவை',
    fixedAmountInvalid: 'ஒவ்வொரு அடுக்கிற்கும் சரியான, எதிர்மறையற்ற நிலையான தொகை தேவை',
  },
};
